import { useEffect, useState } from "react";
import { __ } from '@wordpress/i18n';

const WPRegistrationForm = ({onClickLoginForm}) => {

  const [ alertMsg, setAlertMsg ] = useState('');

  const [formInputData, setFormInputData] = useState({
    first_name: "",
    last_name: "",
  });
  
  const handleClick = (e) => {
    e.preventDefault();
    onClickLoginForm(false);
  }


  const handleFormChange = (e) => {
    setFormInputData({
      ...formInputData,
      [e.target.name]: e.target.value,
    });
  }


  const handleRegSubmit = async (e) => {
    e.preventDefault();
    
    setAlertMsg( 'Working....' );

      const formdata = new FormData();
      formdata.append("action", "hive_support_user_registration");
      formdata.append("nonce", hive_front.security );
      formdata.append("form_data", JSON.stringify(formInputData) );
      
      const request = await fetch(hive_front.ajaxurl, {
        method: "POST",
       
        body: formdata,
      });

      const response = await request.json();

      setAlertMsg( response.data.msg );

  }

  return (
    <>
      <div>
        <h3 class="hs-registration-form-title">{__( "Registration Form", "hive-support" )}</h3>
        <form onSubmit={handleRegSubmit} class="hs-registration-form" action="#" method="post">
        <div class="hs-registration-form-group">
          <label>{__( "First name", "hive-support" )}</label>
          <input type="text" onChange={handleFormChange} value={formInputData.first_name} name="first_name"  />
        </div>

        <div class="hs-registration-form-group">
          <label>{__( "Last Name", "hive-support" )}</label>
          <input type="text" onChange={handleFormChange} value={formInputData.last_name} name="last_name" />
        </div>

        <div class="hs-registration-form-group">
          <label>{__( "Username", "hive-support" )}</label>
          <input type="text" onChange={handleFormChange} value={formInputData.user_login} name="user_login" required />
        </div>

        <div class="hs-registration-form-group">
          <label>{__( "Email Address", "hive-support" )}</label>
          <input type="email" onChange={handleFormChange} value={formInputData.email} name="email" required />
        </div>

        <div class="hs-registration-form-group">
          <label>{__( "Password", "hive-support" )}</label>
          <input type="text" onChange={handleFormChange} value={formInputData.password} name="password" required />
        </div>

        <input type="submit" value="Signup" />
        </form>
        
        <p dangerouslySetInnerHTML={{ __html: alertMsg }}></p>
        <p>{__( "Already have an account?", "hive-support" )} <a onClick={handleClick} href="#">{__( "Login", "hive-support" )}</a></p>

      </div>
    </>
  );

};

export default WPRegistrationForm;
